/**
 * Created by Administrador on 9/30/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('homeController', homeController)
        .controller('loginBranchController', loginBranchController);

    homeController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', '$timeout', 'AuthServerProvider'];
    loginBranchController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', 'userService', '$timeout'];

    function homeController($rootScope, $scope, $state, Auth, Principal, $timeout, AuthServerProvider){

        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.isLoggedIn = Auth.isLoggedIn;
        vm.isErrorLogin = false;


        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        vm.login = function(isValid, user){
            Auth.loginCurrent({
                username: user.email,
                password: user.password
            }, false).then(function(response){
                vm.isErrorLogin = false;
                $state.go('dashboard');
                $rootScope.$broadcast('authenticationSuccess');
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
                window.location.reload(true);
            }, function (error) {
                if(error.status === 400 || error.status === 401 || error.status === 404 || error.status === 500) {
                    vm.isErrorLogin = true;
                    $timeout(function () {
                        vm.closeErrorLogin();
                    }, 4000);
                }
            });
        }

        vm.closeErrorLogin = function () {
            vm.isErrorLogin = false;
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                AuthServerProvider.setUserAccount(account);
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
    }

    function loginBranchController($rootScope, $scope, $state, Auth, Principal, userService, $timeout){

        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.isLoggedIn = Auth.isLoggedIn;
        vm.isErrorLogin = false;
        vm.initUserSession = initUserSession;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        vm.login = function(isValid, user){
            Auth.loginCurrent({
                username: user.email,
                password: user.password
            }).then(function(response){
                vm.isErrorLogin = false;
                $state.go('dashboard');
                $rootScope.$broadcast('authenticationSuccess');

                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }, function (error) {
                if(error.status === 400 || error.status === 401 || error.status === 404 || error.status === 500) {
                    vm.isErrorLogin = true;
                    $timeout(function () {
                        vm.closeErrorLogin();
                    }, 4000);
                }
            });
        }

        vm.closeErrorLogin = function () {
            vm.isErrorLogin = false;
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function initUserSession() {
        }
    }
})();
